import type { ChainType } from "~/api/types";

/** Build a block explorer URL for a transaction hash */
export function getExplorerTxUrl(
  chainType: ChainType,
  explorerUrl: string,
  txHash: string,
): string {
  const base = explorerUrl.replace(/\/$/, "");
  switch (chainType) {
    case "solana":
      return `${base}/tx/${txHash}`;
    case "tron":
      return `${base}/#/transaction/${txHash}`;
    case "evm":
    default:
      return `${base}/tx/${txHash}`;
  }
}

/** Build a block explorer URL for an address */
export function getExplorerAddressUrl(
  chainType: ChainType,
  explorerUrl: string,
  address: string,
): string {
  const base = explorerUrl.replace(/\/$/, "");
  switch (chainType) {
    case "solana":
      return `${base}/account/${address}`;
    case "tron":
      return `${base}/#/address/${address}`;
    case "evm":
    default:
      return `${base}/address/${address}`;
  }
}
